import { Client } from '@lockton-apps/shared/interfaces';
import { concat, filter, intersection, uniqBy } from 'lodash';

export function filterClientAndSubClients(
  clients: Client[],
  clientId: number
): Client[] {
  return clientId
    ? uniqBy(
        concat(
          filter(
            clients,
            (c) => c.relatesToClientId === clientId || c.id === clientId
          )
        ),
        'id'
      )
    : [];
}

export function filterForRelatedClients(
  clients: Client[],
  clientIds: number[]
): Client[] {
  return uniqBy(
    concat(
      filter(
        clients,
        (client) =>
          intersection([client.id, client.relatesToClientId], clientIds)
            .length > 0
      )
    ),
    'id'
  );
}
